import MedicalCheckAgeError from './MedicalCheckAgeError';

export default MedicalCheckAgeError;
